/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Password_PlaceholderInputs */

const en_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your password`)
};

const fr_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre mot de passe`)
};

const de_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihr Passwort ein`)
};

const it_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua password`)
};

const ru_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите свой пароль`)
};

const es_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese su contraseña`)
};

const zh_cn2_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的密码`)
};

const ja_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを入力してください`)
};

const hi_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना कूटशब्द भरें`)
};

const pt_pt2_login_password_placeholder = /** @type {(inputs: Login_Password_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite sua senha`)
};

/**
* | output |
* | --- |
* | "Enter your password" |
*
* @param {Login_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_password_placeholder = /** @type {((inputs?: Login_Password_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Password_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_password_placeholder(inputs)
	if (locale === "de") return de_login_password_placeholder(inputs)
	if (locale === "it") return it_login_password_placeholder(inputs)
	if (locale === "ru") return ru_login_password_placeholder(inputs)
	if (locale === "es") return es_login_password_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_login_password_placeholder(inputs)
	if (locale === "ja") return ja_login_password_placeholder(inputs)
	if (locale === "hi") return hi_login_password_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_login_password_placeholder(inputs)
	return en_login_password_placeholder(inputs)
});